
<template>
  <div class="new_ticket" style="padding-top: 6em;">
    <div id="ticket_responsive" style="display:none;">
            <div id="ticket_inner" style="background-color: #2B6CA0; height: 46px; padding: 3% 7%; ">
                <button class="float-left"  @click="backButton">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00135 9.99865C8.00109 9.8652 8.04757 9.73588 8.13271 9.63312L10.9884 6.20632C11.0853 6.08969 11.2246 6.01634 11.3757 6.00242C11.5267 5.98849 11.677 6.03513 11.7937 6.13208C11.9103 6.22902 11.9837 6.36833 11.9976 6.51935C12.0115 6.67037 11.9649 6.82074 11.8679 6.93737L9.30925 9.99865L11.7765 13.0599C11.824 13.1183 11.8594 13.1856 11.8808 13.2577C11.9022 13.3299 11.9091 13.4055 11.9011 13.4804C11.8932 13.5552 11.8705 13.6277 11.8344 13.6938C11.7983 13.7598 11.7495 13.8181 11.6909 13.8652C11.6321 13.9175 11.5633 13.9571 11.4885 13.9816C11.4138 14.006 11.3348 14.0148 11.2565 14.0073C11.1782 13.9997 11.1023 13.9762 11.0336 13.938C10.9648 13.8998 10.9047 13.8478 10.857 13.7853L8.09844 10.3585C8.02676 10.2528 7.99257 10.1261 8.00135 9.99865Z" fill="white"/>
                    <rect x="19.5" y="0.5" width="19" height="19" rx="3.5" transform="rotate(90 19.5 0.5)" stroke="white"/>
                </svg>
                </button>
        
                <div class="float-left"  id="support_heading" >
                    <p  style="color:white;  font-family:Mulish,sans-serif;font-size: 16px !important;">New Ticket</p>
                </div>
                
            </div>
        

        </div>
    <form class="forms-sample" id="hide_div" style="margin-bottom: 0; border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
      <h6 class="sub-title mb-3 color-default" style="border: 0; margin: 0 !important; padding: 0">
        {{ formHeader }}
      </h6>
    </form>

    <form class="forms-sample"  ref="formContainer" :key="this.$route.params.ticket" style="margin-top:-150px;border: 1px solid rgba(0, 0, 0, 0.1) ">
      
      <div class="form-group row">
        <div class="col-md-12" id="border_left" >
          <div class="col-md-12 margin-bottom style-label">
            <div class="form-group">
              <label>Select Organization</label>
              <multiselect :options="organizations" :allow-empty="false" :selectedLabel="null" :deselectLabel="null" :selectLabel="null" :searchable="true" v-model="ticketForm.org"
                label="name" track-by="organization_id" @input="dropzoneChangeUrl">
              </multiselect>
            </div>
          </div>
          <div class="col-md-12 margin-bottom style-label">
            <label class="label-form" for="message">Title:</label>
            <input v-model="ticketForm.title" class="form-control" type="text" />
          </div>
          <br />
          <div class="col-md-12 margin-bottom style-label">
            <div class="form-group">
              <label>What do you need help with?</label>
              <select v-model="ticketForm.category" class="form-control" style="padding: 5px 10px"
                placeholder="Select category">
                <option v-for="(value, index) in category" :key="index">
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <!-- title input -->
          <div class="col-md-12 margin-bottom style-label">
            <label class="label-form" for="message">Message:</label>
            <tiny-mce-editor :vModelName.sync="ticketForm.message"></tiny-mce-editor>
            <!-- <textarea id="message" v-model="ticketForm.message" placeholder="Message" class="form-control"></textarea> -->
          </div>
          <br />
          <!-- caption input -->
          <div class="col-md-12">
            <vue-dropzone ref="myVueDropzone" id="dropAttach" :options="dropzoneOptions" :style="{'pointer-events':pointerEvent}" ></vue-dropzone>
          </div>
          <div class="col-md-12  style-label" style="padding-top: 20px">
            <input type="checkbox" data-toggle="modal" @click="check($event)" v-model="ticketForm.add_trello" />
            <span class="checkmark"></span>
            <label class="ml-2">Add To Trello</label>
          </div>
          <div v-if="is_show_trello">
            <br />
            <div class="col-md-12">
              <div class="form-group">
                <label>Select board list:</label>
                <select v-model="ticketForm.list_id" class="form-control" style="padding: 5px 10px"
                  placeholder="Select list">
                  <option v-for="(index, list) in board_lists" :key="index">
                    {{ list.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Title:</label>
              <input v-model="ticketForm.list_card_title" class="form-control" type="text" />
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Description:</label>
              <textarea v-model="ticketForm.list_card_desc" class="form-control" type="text" rows="4"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="text-right add_ticket_submit">
          <button class="btn btn-default" @click.prevent="save">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from "axios";
  import "jodit/build/jodit.min.css";
  import JoditVue from "jodit-vue";
  import TinymceEditor from "../../views/partials/tiny_mce_editor";
  import Multiselect from "vue-multiselect";
  import moment from "moment";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";

  Vue.filter("formatDateTime", function (value) {
    if (value) {
      return (
        moment(String(value)).format("DD MMMM, YYYY") +
        " at " +
        moment(String(value)).format("hh:mm:ss A")
      );
    }
  });

  export default {
    components: {
      JoditVue,
      Multiselect,
      vueDropzone: vue2Dropzone,
      "tiny-mce-editor": TinymceEditor,
    },

    data: function () {
       var _this=this;
      var supportedImageFormats = [
        ".jpeg",
        ".jfif",
        ".tiff",
        ".bmp",
        ".jpg",
        ".png",
        ".gif",
      ];
      var supportedDocumentFormats = [
        ".docx",
        ".rtf",
        ".doc",
        ".pdf",
        ".txt",
        ".xls",
        ".xlsx",
      ];
      var supportedVideoFormats = [".mp4", ".avi", ".flv", ".wmv", ".mov"];
      var supportedAudioFormats = [".mp3", ".wav", ".aac"];
      var unique_folder = Math.floor(Math.random() * 90000) + 10000;

      return {
       
        pointerEvent: 'none',
        formHeader: "",
        user_logo: "",
        board_lists: [],
        organizations: [],
        Regex: "a-zA-Z]*$/",
        main_site_url: process.env.VUE_APP_LINENTECH_V3,
        ticketForm: {
          id: 0,
          user_id: 0,
          title: "",
          category: "General Question",
          add_trello: false,
          org: "",
          list_id: "",
          list_card_title: "",
          list_card_desc: "",
          customer_feedback: false,
        },
        remove_file_orgid: "",
        new_url : "",
        category: [
          "General Question",
          "Customization or New Feature Request",
          "Bug/System Error Report",
          "System Improvement Suggestion",
          "Request a call back",
          "Request a zoom meeting",
        ],
        is_show_trello: false,
        supportedImageFormats: supportedImageFormats,
        supportedDocumentFormats: supportedDocumentFormats,
        supportedVideoFormats: supportedVideoFormats,
        supportedAudioFormats: supportedAudioFormats,
        unique_folder: unique_folder,

        buttons: [
          "bold",
          "strikethrough",
          "underline",
          "italic",
          "|",
          "ul",
          "ol",
          "|",
          "image",
          "table",
          "link",
          "|",
          "outdent",
          "indent",
          "|",
          "align",
          "undo",
          "redo",
          "|",
          "hr",
          "symbol",
          "fullsize",
        ],
        config: {
          uploader: {
            insertImageAsBase64URI: true,
          },
        },
        dropzoneOptions: {
          url: process.env.VUE_APP_LINENTECH_V3 + "/upload", // 
          maxFilesize: 12,
          acceptedFiles:
            supportedImageFormats.join(", ") +
            "," +
            supportedDocumentFormats.join(", ") +
            "," +
            supportedVideoFormats.join(", ") +
            "," +
            supportedAudioFormats.join(", "),
          addRemoveLinks: true,
          timeout: 50000,
          maxFiles:5,
          autoProcessQueue: false, 
          init: function () {
              var startUpload = document.getElementById("saveButton");
              let fileStuatus = this.files;
              this.dropzoneFiles = this.files;
              localStorage.setItem("files",this.files);

              $(startUpload).on("click", function() {
                 
                  this.ticketForm.attachment = fileStuatus;
              });
          },
          success: (file,response) => { 
            localStorage.setItem("del_attachement",true);
            localStorage.setItem("filename",response.data);
          },
          error: function (file, response, xhr) {
            if (response == "You can't upload files of this type.") {
              var fileRef;
              (fileRef = file.previewElement) != null
                ? fileRef.parentNode.removeChild(file.previewElement)
                : void 0;
                 _this.$toast.error(`File Not Supported`);
              
            }
            else if(response == "You can not upload any more files."){
             var fileRef;
             (fileRef = file.previewElement) != null
               ? fileRef.parentNode.removeChild(file.previewElement)
               : void 0;
                _this.$toast.error(`Maximum Five Files Allowed`);
            // alert("error")
           }
            return false;
          },
           removedfile: function(file) {
            this.remove_file_orgid = localStorage.getItem('ticket_org_id');
            var name = localStorage.getItem("filename");      
            let fileIndex = this.dropzoneFiles.findIndex(p=>p.name == file.name); 
            this.dropzoneFiles.splice(fileIndex,1)
            var fileRef;
            return (fileRef = file.previewElement) != null ?
                  fileRef.parentNode.removeChild(file.previewElement) : void 0;

           }
          
          },
     
        };
      },

    computed: {},
    created: function () {
      this.getlist();
      this.getOrg();
    },

    methods: {
       backButton(){
            this.$router.go(-1);
        },
      async getOrg() {
        let loader = this.$loading.show({
          loader: "dots",
          container: this.$refs.formContainer,
        });
        const permission = {
      headers: {
        'X-Permission': 'all_organization_list' 
      }
    };
        await axios
          .get("/admin/users/get-all-organizations",permission)
          .then((response) => {
            this.organizations = response.data;
            loader.hide();
          })
          .catch((error) => {
            loader.hide();
          });
      },
      check(e) {
        if (e.target.checked) {
          this.is_show_trello = true;
        } else {
          this.is_show_trello = false;
        }
      },
      getlist() {
        var url = "/support/get-board-list";
        axios
          .post(url, {
            _method: "GET",
          })
          .then((response) => {
            this.board_lists = response.data.data;
            console.lgo
          });
      },
      empty(str) {
        return !str || !/[^\s]+/.test(str);
      },
      save() {
        if (
          this.ticketForm.org == "" ||
          this.ticketForm.message == "" ||
          this.ticketForm.message == undefined ||
          this.ticketForm.category === "" ||
          this.ticketForm.category == undefined
        ) {
          this.$toast.error(`Field can not be empty`);
          // this.$store.dispatch(
          //   "message/update",
          //   {
          //     title: "Alert",
          //     body: `Field can not be empty.`,
          //     class: "warning",
          //     confirm: false,
          //   },
          //   { root: true }
          // );

          return;
        }
        if (this.ticketForm.add_trello) {
          if (
            this.empty(this.ticketForm.list_card_title) ||
            this.ticketForm.list_id == "" ||
            this.empty(this.ticketForm.list_card_desc)
          ) {
             this.$toast.error(`Field can not be empty`);
            // this.$store.dispatch(
            //   "message/update",
            //   {
            //     title: "Alert",
            //     body: `Field can not be empty.`,
            //     class: "warning",
            //     confirm: false,
            //   },
            //   { root: true }
            // );
            return;
          }
        }
         if(this.$refs.myVueDropzone.getUploadingFiles().length == 0){
          this.sendReply(this.ticketForm);
        }else{
          this.$toast.warning(`Files Are Uploading...`);
        }
        localStorage.setItem("del_attachement",false);
      },
      

      // Send Reply to ticket
      sendReply(ticket) {
        let loader = this.$loading.show({
          loader: "dots",
          container: this.$refs.formContainer,
        });
        ticket["unique_folder"] = this.unique_folder;
        ticket["org_id"] = this.ticketForm.org.organization_id;
        this.ticketForm.attachment = this.$refs.myVueDropzone.getAcceptedFiles();
        this.$store
          .dispatch("support/sendReply", ticket)
          .then((data) => {
            // send successful message
            loader.hide();
            this.$router.push("/support");
            setTimeout(() => {
              this.$toast.success(`Ticket has been generated successfully`);
            }, 3000);
            
          })
          .catch((error) => {
            let response = error.response;
            loader.hide();
            this.$router.push("/support");
             setTimeout(() => {
               this.$toast.error(`OOPS! something went wrong`);
            }, 3000);
          });
      },
      dropzoneChangeUrl() {
        this.new_url = process.env.VUE_APP_API_URL+"/api/support/support-files/"+this.ticketForm.org.organization_id+"/"+this.unique_folder;
        localStorage.setItem("ticket_org_id", this.ticketForm.org.organization_id);
        this.$refs.myVueDropzone.dropzone.options.url = this.new_url;
        this.pointerEvent ='auto';
      },
    },
  };
</script>
<style >
.dropzone .dz-progress{
    display: none !important;
  }
/* .multiselect__element .multiselect__option--highlight {
    background: #48a6a6 !important;
  }
  
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option--highlight:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected{
      background: #3776a9 !important;
         /* color: #FFFFFF; */
  /* } */ 
  @media (min-width: 320px) and (max-width:680px){
    .tox.tox-tinymce.tox-platform-touch{
      height: 250px !important;
    }
  }
</style>
<style scoped>
  
  .style-label label {
    color: rgb(72, 166, 166) !important;
  }
  .m-body .m-content {
    padding-bottom: 0;
  }

  #messages_container {
    overflow-y: scroll;
    max-height: 560px;
  }

  .support_message {
    margin-top: 15px;
    width: 60%;
  }

  .support_message.from_admin {
    margin-left: 40%;
  }

  .support_message.from_user span.message_time {
    display: block;
    text-align: right;
  }

  .support_message.from_admin span.message_time {
    display: block;
    text-align: left;
  }

  .support_message .user_logo {
    float: left;
    overflow: hidden;
    border-radius: 50%;
    background: white;
  }

  .support_message.from_admin .user_logo {
    float: right;
    margin-right: 15px;
  }

  .support_message .user_logo img {
    width: 50px;
    height: 50px;
  }

  .support_message .message_content {
    position: relative;
    width: calc(100% - 75px);
    display: inline-block;
    margin-left: 25px;
    background: white;
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
  }

  .support_message.from_admin .message_content {
    width: calc(100% - 90px);
    border: 0;
    border-radius: 10px 0px 10px 10px;
    float: right;
    margin: 0;
    margin-right: 25px;
    background: #48a6a6;
    color: white;
  }

  .support_message .message_content:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    right: 100%;
    top: 0;
    border: 15px solid transparent;
  }

  .support_message.from_user .message_content:before {
    border-right: 0 solid white;
    border-top: 20px solid white;
  }

  .support_message.from_admin .message_content:before {
    right: 0;
    left: 100%;
    border-left: 0 solid #22b9ff;
    border-top: 20px solid #22b9ff;
  }

  .support_message .message_content ul {
    margin: 0;
    padding: 0;
  }

  .support_message .message_content ul li {
    width: 25%;
    float: left;
    text-align: center;
    display: inline-block;
  }

  .support_message .message_content ul li a {
    text-decoration: none;
    color: #0091d5;
    font-weight: 500;
  }

  .support_message.from_admin .message_content ul li a {
    color: white;
  }

  .support_message .message_content ul li a .attachment_icon {
    padding: 10px;
  }

  .support_message .message_content ul li a .attachment_icon i {
    font-size: 66px;
    color: #0091d5;
  }

  .support_message.from_admin .message_content ul li a .attachment_icon i {
    color: white;
  }

  .support_message .message_content ul li a span {
    width: 100%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }

  .support_message .message_content a:hover {
    color: #2739c1;
  }

  .support_message.from_admin .message_content a {
    color: black;
  }

  /* width */
  #messages_container::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  #messages_container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  #messages_container::-webkit-scrollbar-thumb {
    background: #22b9ff;
  }

  /* Handle on hover */
  #messages_container::-webkit-scrollbar-thumb:hover {
    background: #43b3e7;
  }

  textarea {
    resize: vertical;
  }

  /* .dropzone {
    border: 2px solid #22b9ff;
  } */

  select.form-control {
    padding: 0;
    padding-left: 10px;
  }
  @media (min-width: 320px) and (max-width:680px){
    .support_message .message_content ul li a span {
      width: 51px !important;
    }
    #border_left{
      
      border-left: 0px !important;
      /* display: none !important; */
    }
    #hide_div{
      display: none !important;
    }
    label{
      font-size: 0.9rem;
    }
    .support_message{
      width: 100% !important;
    }
    .add_ticket_submit{
      text-align: center !important;
    }
    .forms-sample .row{
      margin: -10px !important;
    }
    .margin-bottom{
      margin-bottom: 0% !important;
      padding-bottom: 0% !important;
    }
    .new_ticket>.forms-sample{
      margin: 0px 0px 0px 0px !important;
    }
    .forms-sample .form-group ,.margin-bottom{
      width: 102% !important;
    }
    #dropAttach{
      padding: 6% 14% !important;
    }
    .support_message:not(.from_admin) .message_content {
      width: calc(100% - 90px) !important;
      background: #d7d7d7 !important;  
    }
    
  }
</style>